var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ozwq4f35ka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ozwq4f35ka)",
    transform: "translate(-12 -325) translate(-4) translate(2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L17.647 0 17.647 17.647 0 17.647z",
    transform: "translate(14 325) translate(1.176 1.176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M14.228 7.382c-.5-2.536-2.728-4.44-5.404-4.44-2.125 0-3.971 1.205-4.89 2.97C1.72 6.147 0 8.022 0 10.294c0 2.434 1.978 4.412 4.412 4.412h9.559c2.029 0 3.676-1.647 3.676-3.677 0-1.94-1.507-3.514-3.42-3.647z",
    transform: "translate(14 325) translate(1.176 1.176)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/weather-icon.2984d5e407fd8cc0eb1f986f09c448cd.svg";
export { ForwardRef as ReactComponent };